import http, {configJson} from "./config/http-configs";

//1.创建流程
export const addFlow = (data) => {
    const url = "/manage/flow/add"
    return http.post(url, data, configJson)
}

export const delFlow = (flowId) => {
    return http.get(`/manage/flow/delete/${flowId}`)
}

// 修改 流程
export const updateFlow = (data) => {
    const url = "/manage/flow/update"
    return http.post(url, data, configJson)
}

//3.查询所有有效流程
export const getValidFlow = (flowType) => {
    const queryParam = {
        business: "VISITOR",
        type: flowType,     // INVITE、BOOK，分表表示邀约流程和预约流程。
        targetType: null, // ALL、DEPARTMENT、PEOPLE，表示流程针对是部门、个人、还是全部。
        targetValue: null, // targetType取值为DEPARTMENT或者PEOPLE的时候，targetValue取对应的值。
        triggerDate: null, // ALL、 WORK_DAY,、NON_WORK_DAY，表示流程是针对工作日、周末、还是全部。
        triggerTimeStart: null,
        triggerTimeEnd: null,
    }
    const url = "/manage/flow/search"
    return http.post(url, queryParam, configJson)
}

